//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalAcquisitionCostWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Acquisition Cost' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalAcquisitionCostWidget;
